
function showRecaptchaError() {
    $('.recaptcha-error').show();
    $('.g-recaptcha iframe').addClass('recaptcha-invalid');
}

function ShowSalesforceRecaptchaError() {
    $('.salesforce-scheduler-recaptcha-error').show();
    $('.g-recaptcha iframe').addClass('recaptcha-invalid');
};

function hideRecaptchaError() {
    $('.recaptcha-error').hide();
    $('.g-recaptcha iframe').removeClass('recaptcha-invalid');
}

function HideSalesforceRecaptchaError() {
    $('.salesforce-scheduler-recaptcha-error').hide();
    $('.g-recaptcha iframe').removeClass('recaptcha-invalid');
}

var onloadCallback = function () {
    $('.recaptcha button[type="submit"]').prop('data-verified', false);
};

var OnLoadCallBackSalesforce = function () {
    $('#BookYourTourNow').data('verified', false);
    $("#BookYourTourNow").prop("disabled", true);
};

var verifyCallback = function (response) {
    console.log(response);
    $('#gRecaptchaResponse').prop("value", response);
    $('#gRecaptchaResponseRealtor').prop("value", response);
    $('.recaptcha button[type="submit"]').prop('data-verified', true);
    hideRecaptchaError();
};

var VerifySalesforceCallback = function (response) {
    console.log(response);
    $('#requestTourRecaptchaResponse').prop("value", response);
    $('#BookYourTourNow').data('verified', true);
    $("#BookYourTourNow").prop("disabled", false);
    hideRecaptchaError();
};

var callbackTimeout = function () {
    $('.recaptcha button[type="submit"]').prop('data-verified', false);
    showRecaptchaError();
};

var CallbackSalesforceTimeout = function () {
    $('#BookYourTourNow').data('verified', false);
    $("#BookYourTourNow").prop("disabled", true);
    ShowSalesforceRecaptchaError();
};




$(document).ready(function () {
    var recaptcha = '<div class="g-recaptcha" data-sitekey="6Ld1-vIUAAAAAPd2TlrEjk0zi76O0PI9_sgnkIbI" data-callback="verifyCallback" data-expired-callback="callbackTimeout" data-error-callback="callbackTimeout"></div>';
    var salesforceReCaptcha = '<div class="g-recaptcha" data-sitekey="6Ld1-vIUAAAAAPd2TlrEjk0zi76O0PI9_sgnkIbI" data-callback="VerifySalesforceCallback" data-expired-callback="CallbackSalesforceTimeout" data-error-callback="CallbackSalesforceTimeout"></div>';
    var viaQRCodeReCaptcha = '<div class="g-recaptcha" style="text-align: -webkit-center;" data-sitekey="6Ld1-vIUAAAAAPd2TlrEjk0zi76O0PI9_sgnkIbI" data-callback="VerifyViaQRCodeCallback" data-expired-callback="CallbackViaQRCodeCallbackTimeout" data-error-callback="CallbackViaQRCodeCallbackTimeout"></div>';

    var recaptchaError = '<div class="recaptcha-error small-12 columns text-center"><p class="no-bottom">The reCAPTCHA was not entered correctly.</p></div>'
    var salesforceReCaptchaError = '<div class="salesforce-scheduler-recaptcha-error small-12 columns text-center"><p class="no-bottom">The reCAPTCHA was not entered correctly.</p></div>'
    var viaQRCodeReCaptchaError = '<div id="RVQC_ReCaptcha_Error" class="small-12 columns text-center"><p class="no-bottom">The reCAPTCHA was not entered correctly.</p></div>'

    $(recaptcha).insertBefore(".recaptcha");
    $(recaptchaError).insertBefore(".recaptcha");

    $(salesforceReCaptcha).insertBefore("#salesforceSchedulerRecaptch");
    $(salesforceReCaptchaError).insertBefore("#salesforceSchedulerRecaptch");

    $(viaQRCodeReCaptcha).insertBefore("#RegisterViaQRCode_Recaptcha");
    $(viaQRCodeReCaptchaError).insertBefore("#RegisterViaQRCode_Recaptcha");

    $('.recaptcha-error').hide();
    $('.salesforce-scheduler-recaptcha-error').hide();
    $('#RVQC_ReCaptcha_Error').hide();

    $('.recaptcha button[type="submit"]').prop('data-verified', false);
    $('#BookYourTourNow').data('verified', false);
    $('#RVQC_SubmitButton').data('verified', false);


    $('form .recaptcha button[type="submit"]').on('click', function (e) {
        if ($(this).prop('data-verified') == false) {
            showRecaptchaError();
            if ($(this.form)[0].checkValidity() == false) {
                $(this.form).submit();
            } else {
                e.preventDefault();
            }
        }
        else {
            hideRecaptchaError();
        }
    });
});
